import React from 'react';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  return (
    <main className="container">
      <div className="card">
        <h2>AWS EUC Pre-Flight Inspection</h2>
        <p>
          A tool for building a business case for AWS End User Computing services. Build WorkSpaces pricing estimates for prospects,
          analyze existing environments for cost optimization opportunities with SynchroNet Click, and generate executive ROI
          summaries.
        </p>
      </div>

      <div className="dashboard-grid">
        <div className="card">
          <h3>WorkSpaces Estimator</h3>
          <p>
            Build a pricing estimate without needing AWS credentials. Size user groups, compare
            running modes, and generate a starting point for a business case.
          </p>
          <Link to="/calculator">
            <button style={{ marginTop: '1rem' }}>Open Estimator</button>
          </Link>
        </div>
        <div className="card">
          <h3>Click Pre-Flight Analysis</h3>
          <p>
            Analyze an existing WorkSpaces environment for cost optimization opportunities.
            Collects real usage data and generates an ROI report for adding Click to a customer environment.
          </p>
          <Link to="/customers">
            <button style={{ marginTop: '1rem' }}>View Customers</button>
          </Link>
        </div>
      </div>

      <div className="card">
        <h3 style={{ marginBottom: '0.75rem' }}>Workflow Overview</h3>
        <div style={{ marginBottom: '1.25rem' }}>
          <strong style={{ fontSize: '0.875rem', textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--color-text-secondary)' }}>
            Estimating a new prospect
          </strong>
          <ol style={{ paddingLeft: '1.25rem', fontSize: '0.9375rem', marginTop: '0.5rem' }}>
            <li style={{ marginBottom: '0.375rem' }}>Go to <strong>Estimator</strong> and configure the prospect's user groups</li>
            <li style={{ marginBottom: '0.375rem' }}>Review AlwaysOn vs AutoStop break-even and savings analysis</li>
            <li>Download the PDF proposal</li>
          </ol>
        </div>
        <div>
          <strong style={{ fontSize: '0.875rem', textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--color-text-secondary)' }}>
            Analyzing an existing environment
          </strong>
          <ol style={{ paddingLeft: '1.25rem', fontSize: '0.9375rem', marginTop: '0.5rem' }}>
            <li style={{ marginBottom: '0.375rem' }}>Go to <strong>Customers</strong> and create a customer account</li>
            <li style={{ marginBottom: '0.375rem' }}>Download and run the PowerShell script or deploy the IAM role in the customer's AWS account</li>
            <li style={{ marginBottom: '0.375rem' }}>Click <strong>Run Pre-Flight</strong> on the Reports page to collect WorkSpaces data</li>
            <li>Download the executive summary PDF from <strong>Reports</strong></li>
          </ol>
        </div>
      </div>
    </main>
  );
};

export default Dashboard;
